import { Box, Paper, Typography } from '@mui/material';
import { common } from '@mui/material/colors';
import type { FC } from 'react';

import SimpleButton from 'components/MUISimpleButton/SimpleButton';
import { WarrTheme } from 'theme/warrcloud';

import useLogin from './hooks/useLogin';
import { TypographyStyled } from './LoginPage.styled';

const LoginPage: FC = () => {
  const { redirectToCognitoLoginPage, redirectToCognitoForgotPasswordPage, isLoginLoading } =
    useLogin();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: "url('/images/signInBackground.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Paper elevation={12}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: common.white,
            width: '400px',
            alignItems: 'center',
            padding: '1.85rem',
            gap: '20px',
            borderRadius: '10px',
          }}
        >
          <img
            alt="warrQueue logo"
            src="/images/loginLogo.png"
            style={{
              alignSelf: 'flex-start',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              color: common.black,
              alignSelf: 'flex-start',
              marginTop: '20px',
              marginBottom: '0px',
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            Sign into WarrChirp
          </Typography>
          <hr style={{ width: '100%', borderTop: '1px solid lightgray' }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: common.white,
              width: '400px',
              alignItems: 'left',
              padding: '1.85rem',
              gap: '20px',
              borderRadius: '10px',
            }}
          ></Box>
          <Box width="100%">
            <SimpleButton
              fullWidth
              label="SIGN IN"
              color={WarrTheme.palette.primary.main}
              size="large"
              variant="contained"
              onClick={redirectToCognitoLoginPage}
              labelColor="white"
              loading={isLoginLoading}
            />
          </Box>
          <Box>
            <TypographyStyled onClick={redirectToCognitoForgotPasswordPage}>
              Trouble signing in?
            </TypographyStyled>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginPage;
